<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="timeValue"    
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="timeValue"
        :label= "pickerLabel"
        append-icon="mdi-calendar"
        readonly
        clearable
        v-on="on"
      />
    </template>
    <v-time-picker
      v-model="timeValue"
      :show-current="showCurrent"
      ampm-in-title
      format="24hr"
      full-width
      scrollable
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        Cancel
      </v-btn>     
    </v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  components: {},
  props: {
    pickerLabel: String,
    timeValue: String  
  },
  data: () => ({
    showCurrent: true,
    menu: false,
    modal: false
  }),
  watch: {
    timeValue (val) {
      this.$emit('dateSelected',val); this.$refs.menu.save(val);
    },
  },
  computed: {},
  methods: {}
}
</script>